/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import './NavLink.scss';

const NavLink = ({
  content, target, isActive,
}) => {
  const className = `${isActive ? 'current-menu-item' : ''}`;
  return (
    <li className={className}>
      <a href={target} className="nav-link">
        {content}
      </a>
    </li>
  );
};

NavLink.propTypes = {
  content: PropTypes.node,
  target: PropTypes.string,
  isActive: PropTypes.bool,
};

NavLink.defaultProps = {
  content: undefined,
  target: undefined,
  isActive: false,
};

export default NavLink;
